/** Zelfde waarden als Worker `purchases.billing_status` (Stripe-webhooks). */

export function purchaseBillingRevoked(status: string): boolean {
  return status === 'refunded' || status === 'dispute_lost';
}

export function purchaseBillingLabelNl(status: string): string {
  switch (status) {
    case 'active':
      return 'Betaald';
    case 'partially_refunded':
      return 'Deels terugbetaald';
    case 'refunded':
      return 'Terugbetaald';
    case 'dispute_open':
      return 'Betalingsgeschil';
    case 'dispute_lost':
      return 'Geschil afgewezen';
    default:
      return status;
  }
}

/** Teksten voor superadmin: welke Stripe-events inschakelen. */
export const STRIPE_WEBHOOK_EVENTS: { type: string; description: string }[] = [
  {
    type: 'checkout.session.completed',
    description: 'Aankoop vastleggen zodra de betaling rond is (bestaande gebruiker met hetzelfde e-mailadres).',
  },
  {
    type: 'checkout.session.async_payment_failed',
    description: 'Openstaande checkout opruimen bij mislukte achterafbetaling (bijv. iDEAL).',
  },
  {
    type: 'checkout.session.expired',
    description: 'Openstaande checkout opruimen als de klant de betaalpagina niet afmaakt.',
  },
  {
    type: 'charge.refunded',
    description: 'Status bijwerken bij (deels) terugbetaling; volledige refund sluit rapport en download af.',
  },
  {
    type: 'charge.dispute.created',
    description: 'Markeert een lopend chargeback-geschil (toegang blijft tot slotuitspraak).',
  },
  {
    type: 'charge.dispute.closed',
    description: 'Herstelt toegang bij gewonnen geschil of sluit af bij verlies / terugbetaling via geschil.',
  },
];
